const KEY = "uto.sidebar.collapsed";

/** The estimator's last choice; a blocked or empty store means expanded. */
export function readCollapsed(): boolean {
  try {
    return window.localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function saveCollapsed(collapsed: boolean): void {
  try {
    window.localStorage.setItem(KEY, collapsed ? "1" : "0");
  } catch {
    // Private windows and blocked storage: the choice lasts for this page only.
  }
}
